<template>
  <div class="add-chapter">
    <WsUpdateMultiLayer
      :modelName="modelName"
      :title="title"
      :label="label"
      :layersSetting="layersSetting"
      :getUrl="$_getUrl"
      :getPayload="$_getPayload"
    ></WsUpdateMultiLayer>
  </div>
</template>
<script>
import model from "@/models/area";
import S_multiLayer from "@/helpers/multiLayer";
export default {
  data(){
    return {
      title: "編輯子地區",
      label: "地區",
      modelName: model.modelName,
      layersSetting: {
        getLayersKey: 'area_sections',
        fields: {
          btn: [
            {
              text: "新增",
              icon: "mdi-plus",
              color: "primary",
              outline: true,
              isCreateSubLayer: false,
            },
            {
              text: "新增子層",
              icon: "mdi-plus",
              color: "primary",
              outline: true,
              isCreateSubLayer: true,
              $_visibility(layer){
                return layer.layers && layer.layers.length > 0
                ? false
                : true
              },
            }
          ],
          component: "WsTitleInput",
          props: {
            fields: {
              name: {
                label: "",
                type: "text",
                sm: 12,
              },
            },
            description: '請再三確認，此地區以下的子地區也會一併刪除。'
          },
        }
      },
    }
  },
  methods: {
    $_getUrl(type, data) {
      let url = ''
      if (type === 'update') {
        url = `area_section/${data.id}`
      } else if (type === 'delete') {
        url = `area_section/${data}`
      } else if (type === 'create') {
        url = `area/${this.$route.params.id}/area_section`
      } else if (type === 'sort') {
        url = `area_section_sequence`
      }
      return url
    },
    $_getPayload(type, data) {
      let result = null
      if (type === "update") {
        result = {
          "locales": {
            "tw": {
              "name": data.name
            }
          }
        }
      } else if (type === "create") {
        result = {
          "area_section": data.parent_id ? data.parent_id : null,
          "locales": {
            "tw": {
              "name":  data.name
            }
          }
        }
      } else if (type === "sort") {
        const keys = {
          valueKey: 'id',
          getLayersKey: 'layers',
          setLayersKey: 'area_sections',
        }
        const resultLayer = S_multiLayer.setItems(data, keys)
        result = { ["area_sections"] : resultLayer }
      }
      return result
    }
  }
};
</script>